const founderGalleryModal = document.getElementById('founderGalleryModal');
const openFounderGallery = document.getElementById('openFounderGallery');
const closeFounderGallery = document.getElementById('closeFounderGallery');

function setFounderGalleryState(isOpen) {
  founderGalleryModal.classList.toggle('is-open', isOpen);
  founderGalleryModal.setAttribute('aria-hidden', String(!isOpen));
  document.body.style.overflow = isOpen ? 'hidden' : '';
}

openFounderGallery.addEventListener('click', () => setFounderGalleryState(true));
closeFounderGallery.addEventListener('click', () => setFounderGalleryState(false));
founderGalleryModal.addEventListener('click', (event) => {
  if (event.target === founderGalleryModal) setFounderGalleryState(false);
});
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape' && founderGalleryModal.classList.contains('is-open')) {
    setFounderGalleryState(false);
  }
});

const prEnquiryForm = document.getElementById('prEnquiryForm');
const prFormStatus = document.getElementById('prFormStatus');

if (prEnquiryForm && prFormStatus) {
  prEnquiryForm.addEventListener('submit', (event) => {
    event.preventDefault();

    const formData = new FormData(prEnquiryForm);
    const name = String(formData.get('name') || '').trim();
    const email = String(formData.get('email') || '').trim();
    const publication = String(formData.get('publication') || '').trim();
    const enquiryType = String(formData.get('enquiry_type') || 'Not specified').trim() || 'Not specified';
    const message = String(formData.get('message') || '').trim() || 'Not provided';

    const recipients = 'info@kaayurituals.com,anjanjyot@garagecollective.agency';
    const subject = encodeURIComponent(`PR Enquiry from ${name || 'Website Visitor'}`);
    const body = encodeURIComponent(
      `Name: ${name}\n` +
      `Email: ${email}\n` +
      `Publication / Platform: ${publication}\n` +
      `Type of Enquiry: ${enquiryType}\n\n` +
      `Message:\n${message}`
    );

    prFormStatus.textContent = 'Opening your email app with the enquiry addressed to both recipients.';
    window.location.href = `mailto:${recipients}?subject=${subject}&body=${body}`;

    setTimeout(() => {
      prFormStatus.textContent = 'Draft opened. Send the email from your mail app to complete the enquiry.';
    }, 400);
  });
}
